module.exports = "<div disable-tooltip-on-overflow>\n\t<div class=\"overflow-ellipsis\">\n\t\t{{ row.entity.toUserFirendlyQuerySrting() }}\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/modules/distribution/components/bundle/create/cellTemplates/query.cell.template.view.html
// module id = 511
// module chunks = 7